import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoaderService {
  private isLoading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public setLoading(isLoading: boolean): void {
    this.isLoading$.next(isLoading);
  }

  public getIsLoading$(): BehaviorSubject<boolean> {
    return this.isLoading$;
  }
}
